














































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';

@Component
export default class ProductDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;

  public unitPriceVersion = 1;
  public profitMarginVersion = 1;

  public purchasePriceChanged(rec) {
    if (rec.purchase_unit_price) {
      if (rec.profit_margin) {
        rec.unit_price =
          Math.round(
            (rec.profit_margin / 100 + 1) * rec.purchase_unit_price * 100
          ) / 100;
      } else {
        rec.unit_price = rec.purchase_unit_price;
        this.unitPriceChanged(rec);
      }
      this.unitPriceVersion += 1;
    }
  }

  public profitMarginChanged(rec) {
    if (rec.profit_margin != null && rec.purchase_unit_price) {
      rec.unit_price =
        Math.round(
          (rec.profit_margin / 100 + 1) * rec.purchase_unit_price * 100
        ) / 100;
      this.unitPriceVersion += 1;
    }
  }

  public unitPriceChanged(rec) {
    if (rec.purchase_unit_price && rec.unit_price) {
      rec.profit_margin =
        Math.round((rec.unit_price / rec.purchase_unit_price - 1) * 100 * 100) /
        100;
      this.profitMarginVersion += 1;
    }
  }
}
